import { googleAnalyticsId } from "_services/common.service";

interface GtagObj {
  [key: string]: string | number | undefined;
}
declare global {
  interface Window {
    gtag?: (command: string, idOrActionOrParams: string | GtagObj, params?: GtagObj) => void;
  }
}

// lib/ga.ts
export const GA_ID = googleAnalyticsId || '';

interface GAEvent {
  action: string;
  category: string;
  label?: string;
  value?: number;
}

// Track pageviews
export const pageview = (url: string) => {
    if (!GA_ID || typeof window === 'undefined' || !window.gtag) return;

    window.gtag('config', GA_ID, {
        page_path: url,
    });
};

// Track custom events
export const event = ({ action, category, label, value }: GAEvent) => {
    if (!GA_ID || typeof window === 'undefined' || !window.gtag) return;

    window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value,
    });
};
